import React from "react";
import { useApi } from "../hooks/useApi";

const card = { background: "#0d1224", border: "1px solid #1e2a45", borderRadius: "10px", padding: "16px" };
const row  = { display: "flex", gap: "12px", flexWrap: "wrap" };
const tile = { flex: "1", minWidth: "120px", background: "#111827", borderRadius: "8px", padding: "12px", textAlign: "center" };
const lbl  = { fontSize: "11px", color: "#64748b", marginBottom: "4px" };
const val  = (c) => ({ fontSize: "22px", fontWeight: 700, color: c });
const badge = (c) => ({ display: "inline-block", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", background: c + "22", color: c });

function roroColor(v) {
  if (!v) return "#64748b";
  return v >= 28 ? "#22c55e" : v >= 18.5 ? "#60a5fa" : "#ef4444";
}

export default function MacroPanel() {
  const { data, loading, error } = useApi("/status", 30000);

  if (loading) return (
    <div style={card}>
      <div style={{ color: "#475569", fontSize: "13px" }}>📊 Loading macro data...</div>
    </div>
  );

  if (error) return (
    <div style={card}>
      <div style={{ color: "#ef4444", fontSize: "13px" }}>📊 Macro — Brain offline: {error}</div>
    </div>
  );

  const macro = data?.macro || {};
  const roro = macro.roro  || 0;
  const vix  = macro.vix   || 0;
  const dxy  = macro.dxy_trend || "—";
  const y10  = macro.yield_10y || 0;
  const fed  = macro.fed_rate  || 0;
  const regime = roro >= 28 ? "RISK-ON 🟢" : roro >= 18.5 ? "NEUTRAL 🟡" : "RISK-OFF 🔴";

  return (
    <div style={card}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
        <span style={{ fontWeight: 600, color: "#94a3b8" }}>📊 Macro Regime</span>
        <span style={badge(roroColor(roro))}>{regime}</span>
      </div>
      <div style={row}>
        {[
          { label: "RORO Index",  value: roro.toFixed(2),  sub: "SPY / VIX",    color: roroColor(roro) },
          { label: "VIX",         value: vix.toFixed(2),   sub: "Fear Index",   color: vix >= 30 ? "#ef4444" : vix >= 20 ? "#f59e0b" : "#22c55e" },
          { label: "DXY Trend",   value: dxy === "UP" ? "↑ UP" : dxy === "DOWN" ? "↓ DOWN" : "→ FLAT", sub: "USD Index", color: dxy === "UP" ? "#ef4444" : dxy === "DOWN" ? "#22c55e" : "#94a3b8" },
          { label: "10Y Yield",   value: y10.toFixed(2) + "%", sub: "US Treasury", color: "#60a5fa" },
          { label: "Fed Rate",    value: fed.toFixed(2) + "%", sub: "FEDFUNDS",    color: "#a78bfa" },
          { label: "API Status",  value: data?.api ? "● LIVE" : "● DOWN", sub: "Brain", color: data?.api ? "#22c55e" : "#ef4444" },
        ].map((t) => (
          <div key={t.label} style={tile}>
            <div style={lbl}>{t.label}</div>
            <div style={val(t.color)}>{t.value}</div>
            <div style={{ fontSize: "10px", color: "#475569" }}>{t.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
